import { inject } from 'vue';
import { TRACETAIL_KEY } from '../injection-keys';

export function useTraceTail() {
  const tracetail = inject(TRACETAIL_KEY);

  if (!tracetail) {
    throw new Error(
      '[TraceTail] No TraceTail instance found. ' +
      'Make sure to install the TraceTail plugin at the app level.'
    );
  }

  return tracetail;
}